// import { MapsAPILoader } from '@agm/core';
import {
  Component,
  ElementRef,
  Inject,
  NgZone,
  OnInit,
  ViewChild,
} from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatDialog,
} from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { countries } from 'src/@order/commonData/commonUiData';
import { LocationPointType } from 'src/@order/commonData/location-point-type';
import { DataService } from 'src/@order/services/data.service';
import { MapApiKey, OrderLocations } from 'src/app/utils/systemEnums';
import { Loader } from '@googlemaps/js-api-loader';
import { AuthServiceLocal } from 'src/@order/services/auth.service';
import { WebDestinationsDialogComponent } from '../web-destinations-dialog/web-destinations-dialog.component';
import { take } from 'rxjs/operators';

interface mode {
  add: boolean;
  update: boolean;
}

@Component({
  selector: 'app-add-bulk-dropoff-dialog',
  templateUrl: './add-bulk-dropoff-dialog.component.html',
  styleUrls: ['./add-bulk-dropoff-dialog.component.scss'],
})
export class AddBulkDropoffDialogComponent implements OnInit {
  countries = countries;
  mode: mode = {
    add: false,
    update: false,
  };
  customerData;
  isInterRegional: boolean = false; // Flag to enable location validation for inter-regional component
  countryRestriction = {
    latLngBounds: {},
    strictBounds: false,
  };
  form!: FormGroup;
  // latitude!: any;
  // longitude!: any;
  // zoom: number;
  ghanaBounds = {
    east: 1.0601216976, // right
    north: 11.0994559693, // TOP
    south: 4.71046214438, // bottom
    west: -3.24437008301, // left
  };

  nigeriaBounds = {
    east: 14.5771777686, // right
    north: 13.8659239771, // TOP
    south: 4.24059418377, // bottom
    west: 2.69170169436, // left
  };
  selectedCountryCode: string;
  address!: string;
  mapLoadingTimes = 0;
  // private geoCoder;
  selectedCountry;

  @ViewChild('search', { static: true })
  public searchElementRef!: ElementRef;

  latitude: number = 12.34;
  longitude: number = 56.78;
  zoom: number = 8;
  formatedAddress: string;
  geoCoder: google.maps.Geocoder;
  currentPlaceId: string = ''; // Store the current place ID
  locality: string = ''; // Store the current locality

  mapOptions: google.maps.MapOptions = {
    restriction: {
      latLngBounds: {
        north: 15,
        south: 4,
        east: 20,
        west: -10,
      },
      strictBounds: true,
    },
  };

  markerOptions: google.maps.MarkerOptions = {
    draggable: true,
  };

  constructor(
    @Inject(MAT_DIALOG_DATA) public _data: any,
    public _matDialogRef: MatDialogRef<AddBulkDropoffDialogComponent>,
    // private mapsAPILoader: MapsAPILoader,
    private ngZone: NgZone,
    private _dataService: DataService,
    private afs: AngularFirestore,
    private _matsnackbar: MatSnackBar,
    private _fb: FormBuilder,
    private _matDialog: MatDialog,
    private _auth: AuthServiceLocal
  ) {
    this.customerData = JSON.parse(localStorage.getItem('authUser'));

    this.setCountryRestriction();

    this.countries.map((country) => {
      if (country.title == this.selectedCountry) {
        country.selected = 1;
        this.selectedCountryCode = country.code;
      } else {
        country.selected = 0;
      }
    });
  }

  ngOnInit(): void {
    this.loadPlaceAutoComplete();

    // Set isInterRegional flag from data
    this.isInterRegional = this._data?.isInterRegional || false;

    // console.log("this._data?.location", this._data?.location);

    if (this._data?.location) {
      this.mode.update = true;
      this.mode.add = false;
      this.createForm(this._data?.location);
      this.latitude = this._data?.location.latitude;
      this.longitude = this._data?.location.longitude;
      // Preserve existing place ID if available
      this.currentPlaceId =
        this._data?.location.placeId || this._data?.location.place_id || '';
      // Preserve existing locality if available
      this.locality = this._data?.location.locality || '';
      this.getAddress(
        this._data?.location.latitude,
        this._data?.location.longitude
      );
    } else {
      this.mode.add = true;
      this.mode.update = false;
      this.createForm();
      this.setCurrentLocation();
    }
  }

  setCountryRestriction() {
    this.selectedCountry = localStorage.getItem('country');

    switch (this.selectedCountry) {
      case 'Ghana':
        this.countryRestriction['latLngBounds'] = this.ghanaBounds;
        this.countryRestriction['strictBounds'] = true;
        break;

      case 'Nigeria':
        this.countryRestriction['latLngBounds'] = this.nigeriaBounds;
        this.countryRestriction['strictBounds'] = true;
        break;
    }
  }

  createForm(data = null) {
    this.form = this._fb.group({
      pickupAddress: [data?.address || '', Validators.required],
      landMark: [data?.landmark || ''],
    });
  }

  // Get Current Location Coordinates
  private setCurrentLocation() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        this.latitude = position.coords.latitude;
        this.longitude = position.coords.longitude;
        this.zoom = 8;
        this.getAddress(this.latitude, this.longitude);
      });
    }
  }

  getAddress(latitude, longitude) {
    if (this.geoCoder)
      this.geoCoder?.geocode(
        { location: { lat: latitude, lng: longitude } },
        (results, status) => {
          // console.log("results", results);
          if (status === 'OK') {
            if (results[0]) {
              if (!this.zoom) this.zoom = 12;
              this.address = results[0].formatted_address;
              this.handleAddressChange(results[0]);
              this.mapLoadingTimes++;
            } else {
              window.alert('No results found');
            }
          } else {
            window.alert('Geocoder failed due to: ' + status);
          }
        }
      );
  }

  markerDragEnd(event: google.maps.MapMouseEvent) {
    if (event.latLng) {
      this.latitude = event.latLng.lat();
      this.longitude = event.latLng.lng();
      this.getAddress(this.latitude, this.longitude);
    }
  }

  public handleAddressChange(address) {
    console.log('address', address);

    // Capture the place ID from the address object
    this.currentPlaceId = address.place_id || '';
    console.log('captured place_id:', this.currentPlaceId);

    const addCompLength = address.address_components.length;
    console.log('address.address_components', address.address_components);

    const addressParts = {
      landMark: address.address_components.filter((item) => {
        if (item.types[2] == 'sublocality_level_1') return item.long_name;
      })[0],

      city: address.address_components.filter((item) => {
        if (item.types[0] == 'administrative_area_level_2')
          return item.long_name;
      })[0],

      state: address.address_components.filter((item) => {
        if (item.types[0] == 'administrative_area_level_1')
          return item.long_name;
      })[0],

      country: address.address_components.filter((item) => {
        if (item.types[0] == 'country') return item.long_name;
      })[0],

      zipcode: address.address_components.filter((item) => {
        if (item.types[0] == 'postal_code') return item.long_name;
      })[0],

      locality: address.address_components.filter((item) => {
        if (item.types[0] == 'locality') return item.long_name;
      })[0],
    };

    console.log('addressParts', addressParts);

    if (addressParts['country']?.long_name && addCompLength)
      if (addressParts['country'].long_name != this.selectedCountry) {
        this.countryUnmatched();
      } else {
        this.formatedAddress = address?.formatted_address;
        this.form.get('pickupAddress').setValue(address?.formatted_address);
      }
    if (addressParts?.landMark && this._data.isPickup) {
      this.form.get('landMark').setValue(addressParts.landMark.long_name);
    }

    if (addressParts['locality']?.long_name && addCompLength) {
      this.locality = addressParts['locality']?.long_name || '';
    }
  }

  countryUnmatched() {
    if (this.form.get('pickupAddress').value) {
      this.form.get('landMark').setValue('');
      this.form.get('landMark').reset();
      this.form.get('pickupAddress').setValue('');
      this.form.get('pickupAddress').reset();
      this.form.updateValueAndValidity();
      this._matsnackbar.open(
        `Your selected location is not in ${this.selectedCountry}. Please pick a place within ${this.selectedCountry}.`,
        'Okay',
        { duration: 10000 }
      );
    }
  }

  loadPlaceAutoComplete() {
    // Check if Google Maps is already loaded
    if (typeof google !== 'undefined' && google.maps) {
      this.initializeGoogleMaps();
      return;
    }

    // Only load if not already present
    const loader = new Loader({
      apiKey: MapApiKey,
      libraries: ['places'],
    });

    loader
      .load()
      .then(() => {
        this.initializeGoogleMaps();
      })
      .catch((error) => {
        console.error('Failed to load Google Maps:', error);
      });
  }

  private initializeGoogleMaps() {
    this.geoCoder = new google.maps.Geocoder();

    const autocomplete = new google.maps.places.Autocomplete(
      this.searchElementRef?.nativeElement,
      {
        componentRestrictions: {
          country: localStorage.getItem('country') === 'Ghana' ? 'GH' : 'NG',
        },
      }
    );

    autocomplete.addListener('place_changed', () => {
      this.ngZone.run(() => {
        const place: google.maps.places.PlaceResult = autocomplete.getPlace();

        if (!place.geometry || !place.geometry.location) {
          return;
        }

        this.latitude = place.geometry.location.lat();
        this.longitude = place.geometry.location.lng();
        this.zoom = 12;

        // Capture place ID from autocomplete selection
        this.currentPlaceId = place.place_id || '';
        console.log(
          'captured place_id from autocomplete:',
          this.currentPlaceId
        );

        this.getAddress(this.latitude, this.longitude);
      });
    });
  }

  /**
   * Handle location selection with validation for inter-regional component
   * Similar to PickupLocationsDialogComponent.handleLocationSelection
   */
  handleLocationSelection(result: any) {
    try {
      console.log('[AddBulkDropoffDialog] handleLocationSelection:enter', {
        isInterRegional: this.isInterRegional,
        result: result,
      });

      if (this.isInterRegional) {
        const webDestinations = JSON.parse(
          localStorage.getItem('webDestinations') || '[]'
        );
        console.log(
          '[AddBulkDropoffDialog] handleLocationSelection:webDestinations:count',
          webDestinations?.length
        );

        const destination =
          webDestinations.find(
            (item: any) =>
              item.destination_name?.toLowerCase() ===
              result?.locality?.toLowerCase()
          ) ||
          webDestinations.find((dest) => {
            const addressParts = result?.address
              ?.split(',')
              .map((p) => p.trim().toLowerCase());
            return addressParts?.some(
              (part) => part === dest.destination_name.toLowerCase()
            );
          });

        console.log(
          '[AddBulkDropoffDialog] handleLocationSelection:destination:match',
          Boolean(destination)
        );

        if (destination) {
          console.log(
            '[AddBulkDropoffDialog] handleLocationSelection:found_destination',
            destination
          );
          const payload = {
            ...result,
            destinationAddress: destination.destination_name,
          };
          console.log(
            '[AddBulkDropoffDialog] handleLocationSelection:returning_payload',
            payload
          );
          return payload;
        } else {
          // Try reverse geocoding
          const lat = result?.lat ?? result?.latitude;
          const lng = result?.long ?? result?.lng ?? result?.longitude;
          console.log(
            '[AddBulkDropoffDialog] handleLocationSelection:reverseGeocode:candidates',
            {
              lat: lat,
              lng: lng,
              placeId: result?.placeId || result?.placeID || result?.place_id,
            }
          );

          if (lat != null && lng != null) {
            this._auth
              .reverseGeoCode({ lat: lat, long: lng })
              .pipe(take(1))
              .subscribe({
                next: (res: any) => {
                  console.log(
                    '[AddBulkDropoffDialog] handleLocationSelection:reverseGeocode:success',
                    res
                  );
                  const resultsArr = res?.data?.results || res?.results || [];
                  const target = String(
                    result?.placeId || result?.placeID || result?.place_id || ''
                  );
                  const foundObj = resultsArr.find(
                    (r: any) => String(r?.place_id) === target
                  );
                  const found = Boolean(foundObj);
                  console.log(
                    '[AddBulkDropoffDialog] handleLocationSelection:reverseGeocode:place_match',
                    {
                      found: found,
                      target: target,
                      results: resultsArr?.length,
                    }
                  );

                  if (found) {
                    // Try to match address_components to a webDestination by regionName
                    console.log(
                      '[AddBulkDropoffDialog] handleLocationSelection:reverseGeocode:address_components',
                      foundObj?.address_components
                    );
                    let matchedDestination: any = null;
                    try {
                      const addressComponents =
                        foundObj?.address_components || [];
                      const candidateNames: string[] = [];
                      addressComponents?.forEach((comp: any) => {
                        const longName = String(comp?.long_name || '')
                          .trim()
                          .toLowerCase();
                        const shortName = String(comp?.short_name || '')
                          .trim()
                          .toLowerCase();
                        if (longName) candidateNames.push(longName);
                        if (shortName) candidateNames.push(shortName);
                      });
                      console.log(
                        '[AddBulkDropoffDialog] handleLocationSelection:reverseGeocode:candidateNames',
                        candidateNames
                      );

                      matchedDestination = (webDestinations || []).find(
                        (dest: any) => {
                          const region = String(dest?.regionName || '')
                            .trim()
                            .toLowerCase();
                          return region && candidateNames.includes(region);
                        }
                      );

                      console.log(
                        '[AddBulkDropoffDialog] handleLocationSelection:reverseGeocode:matchedDestination',
                        matchedDestination
                      );
                    } catch {}

                    if (matchedDestination?.destination_name) {
                      const payload = {
                        ...result,
                        destinationAddress:
                          matchedDestination?.destination_name,
                      };
                      console.log(
                        '[AddBulkDropoffDialog] handleLocationSelection:returning_payload_from_reverseGeocode',
                        payload
                      );
                      this._matDialogRef.close(payload);
                    } else {
                      console.log(
                        '[AddBulkDropoffDialog] handleLocationSelection:openDialog:WebDestinationsDialogComponent:no_match'
                      );
                      const dialogRef = this._matDialog.open(
                        WebDestinationsDialogComponent,
                        {
                          panelClass: ['commonDialogWrapper'],
                          backdropClass: 'dialogBackdrop',
                          autoFocus: false,
                          width: '610px',
                          data: {
                            webDestinations: webDestinations,
                            location: result,
                          },
                        }
                      );
                    }
                  } else {
                    console.log(
                      '[AddBulkDropoffDialog] handleLocationSelection:openDialog:WebDestinationsDialogComponent:no_match'
                    );
                    const dialogRef = this._matDialog.open(
                      WebDestinationsDialogComponent,
                      {
                        panelClass: ['commonDialogWrapper'],
                        backdropClass: 'dialogBackdrop',
                        autoFocus: false,
                        width: '610px',
                        data: {
                          webDestinations: webDestinations,
                          location: result,
                        },
                      }
                    );
                  }
                },
                error: (err) => {
                  console.log(
                    '[AddBulkDropoffDialog] handleLocationSelection:reverseGeocode:error',
                    err
                  );
                  const dialogRef = this._matDialog.open(
                    WebDestinationsDialogComponent,
                    {
                      panelClass: ['commonDialogWrapper'],
                      backdropClass: 'dialogBackdrop',
                      autoFocus: false,
                      width: '610px',
                      data: {
                        webDestinations: webDestinations,
                        location: result,
                      },
                    }
                  );
                },
              });
          } else {
            console.log(
              '[AddBulkDropoffDialog] handleLocationSelection:openDialog:WebDestinationsDialogComponent:no_coords'
            );
            const dialogRef = this._matDialog.open(
              WebDestinationsDialogComponent,
              {
                panelClass: ['commonDialogWrapper'],
                backdropClass: 'dialogBackdrop',
                autoFocus: false,
                width: '610px',
                data: { webDestinations: webDestinations, location: result },
              }
            );
          }
        }
      } else {
        // For non-inter-regional components, return the result as-is
        console.log(
          '[AddBulkDropoffDialog] handleLocationSelection:returning_result_passthrough',
          result
        );
        return result;
      }
    } catch (err) {
      console.log(
        '[AddBulkDropoffDialog] handleLocationSelection:exception',
        err
      );
      // Return the original result on error
      return result;
    }
  }

  onSubmit() {
    if (!this.latitude && !this.longitude) {
      this._matsnackbar.open(
        `The location you entered cannot be located on the GPS. Please enter & choose a location closest to your desired address. Thanks`,
        'OKAY',
        { duration: 8000 }
      );
    } else {
      const timestamp = new Date();
      const userId = this.customerData.id;
      const locationPoint: LocationPointType = this.createAddLocationObj(
        null,
        userId,
        timestamp
      );

      // For inter-regional component, validate the location
      if (this.isInterRegional) {
        const validatedLocation = this.handleLocationSelection(locationPoint);
        if (validatedLocation) {
          this._matDialogRef.close(validatedLocation);
        }
        // If validation fails, the WebDestinationsDialogComponent will be opened
        // and the dialog will be closed automatically
      } else {
        // For non-inter-regional components, proceed as usual
        this._matDialogRef.close(locationPoint);
      }
    }
  }

  locationChange() {
    this.latitude = null;
    this.longitude = null;
    this.currentPlaceId = ''; // Reset place ID when location changes
    this.locality = ''; // Reset locality when location changes
  }

  createAddLocationObj(data = null, userId, timestamp) {
    return {
      address: String(this.form.value?.pickupAddress) || '',
      countryCode: String(this.selectedCountryCode),
      dialCode: String(this.selectedCountryCode),
      fullAddress: '',
      id: data?.id || `${userId}_${timestamp.getTime()}`,
      isPickup: Number(0),
      landmark: String(this.form.value?.landMark) || '',
      latitude: Number(this.latitude),
      locationId: data?.locationId || `${userId}_${timestamp.getTime()}`,
      longitude: Number(this.longitude),
      mobile: String(this._data.mobile),
      name: String(this._data.name),
      phone: String(this._data.mobile),
      time: String(timestamp),
      timestamp: Number(timestamp.getTime()),
      updateAt: Number(timestamp.getTime()),
      userID: data?.userId || Number(userId),
      placeId: String(this.currentPlaceId) || '', // Use the captured place ID
      place_id: String(this.currentPlaceId) || '', // Also add place_id for compatibility
      locality: String(this.locality) || '', // Include locality in the result
    };
  }
}
